(function () {
  const DESKTOP_QUERY = "(min-width: 990px) and (pointer: fine)";
  const ITEM_SELECTOR = ".navigation-item.has-sub-menu";
  const LINK_SELECTOR = ":scope > a";

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function closeAll(nav) {
    nav
      .querySelectorAll(`${ITEM_SELECTOR}.is-open`)
      .forEach(li => {
        li.classList.remove("is-open");
        const a = li.querySelector(LINK_SELECTOR);
        if (a) a.setAttribute("aria-expanded", "false");
      });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const nav = document.querySelector(".navigation-main");
    if (!nav) return;

    const items = nav.querySelectorAll(ITEM_SELECTOR);

    items.forEach(li => {
      const link = li.querySelector(LINK_SELECTOR);
      if (!link) return;

      link.setAttribute("aria-haspopup", "true");
      link.setAttribute("aria-expanded", "false");

      link.addEventListener("click", e => {
        if (!isDesktop()) return;

        // 🚫 NO navegar
        e.preventDefault();
        e.stopPropagation();

        const isOpen = li.classList.contains("is-open");
        closeAll(nav);

        if (!isOpen) {
          li.classList.add("is-open");
          link.setAttribute("aria-expanded", "true");
        }
      });
    });

    // Click fuera → cerrar
    document.addEventListener("click", e => {
      if (!nav.contains(e.target)) closeAll(nav);
    });

    // ESC → cerrar
    document.addEventListener("keydown", e => {
      if (e.key === "Escape") closeAll(nav);
    });
  });
})();
/* Retiro en tienda activado 22-oct-2026: se desactiva el ocultamiento del bloque.
function ocultarPickup() {
  document.querySelectorAll('pickup-availability').forEach(function(el) {
    el.style.display = 'none';
  });
}

document.addEventListener('DOMContentLoaded', ocultarPickup);
window.addEventListener('load', ocultarPickup);
setTimeout(ocultarPickup, 500);
setTimeout(ocultarPickup, 1500);
*/